import { store } from "../state/index.ts";
import * as api from "../services/api.ts";
import * as toast from "./toast.js";

// DOM elements
let navUserName = null;
let logoutBtn = null;
let googleLoginBtn = null;
let userDropdownWrapper = null;
let adminPanelLink = null;
let coachLink = null;

// Callbacks
let onConfigLoaded = null;
let onAuthStateChanged = null;

export function initAuth(elements, callbacks = {}) {
    navUserName = elements.navUserName;
    logoutBtn = elements.logoutBtn;
    googleLoginBtn = elements.googleLoginBtn;
    userDropdownWrapper = elements.userDropdownWrapper;
    onConfigLoaded = callbacks.onConfigLoaded;
    onAuthStateChanged = callbacks.onAuthStateChanged;

    adminPanelLink = document.getElementById("adminPanelLink");
    coachLink = document.getElementById("coachLink");

    logoutBtn?.addEventListener("click", handleLogout);
}

export function showLoggedIn(user) {
    if (!navUserName || !googleLoginBtn || !userDropdownWrapper) {
        return;
    }
    navUserName.textContent = user.displayName || user.fullName || user.email;
    userDropdownWrapper.classList.remove("hidden");
    googleLoginBtn.classList.add("hidden");
    adminPanelLink?.classList.toggle("hidden", !user.admin);
    coachLink?.classList.toggle("hidden", !user.admin);
    store.set('user.currentUser', user);
    if (onAuthStateChanged) {
        onAuthStateChanged(true);
    }
}

export function showLoggedOut() {
    if (!navUserName || !googleLoginBtn || !userDropdownWrapper) {
        return;
    }
    navUserName.textContent = "";
    userDropdownWrapper.classList.add("hidden");
    googleLoginBtn.classList.remove("hidden");
    adminPanelLink?.classList.add("hidden");
    store.set('user.currentUser', null);
    if (onAuthStateChanged) {
        onAuthStateChanged(false);
    }
}

async function handleLogout() {
    try {
        await api.logout();
    } finally {
        // Reload the page to clear all user data (repertoires, imports, etc.)
        window.location.reload();
    }
}

export async function refreshAuthState() {
    try {
        const user = await api.fetchAuthMe();
        if (!user) {
            showLoggedOut();
            return;
        }
        showLoggedIn(user);
        await loadUserConfigFromServer();
        await loadLichessStatus();
        handleLichessRedirectParam();
    } catch (error) {
        console.error("Failed to refresh auth state", error);
        showLoggedOut();
    }
}

async function loadLichessStatus() {
    try {
        const status = await api.fetchLichessStatus();
        store.set('user.lichessConnected', status.connected || false);
        store.set('user.lichessUsername', status.username || null);
    } catch (error) {
        console.error("Failed to load Lichess status", error);
    }
}

function handleLichessRedirectParam() {
    const params = new URLSearchParams(window.location.search);
    const lichessParam = params.get("lichess");
    if (lichessParam === "connected") {
        showToast("Lichess account connected successfully!");
        // Clean URL
        const url = new URL(window.location);
        url.searchParams.delete("lichess");
        window.history.replaceState({}, "", url.pathname + url.search);
    } else if (lichessParam === "error") {
        showToast("Failed to connect Lichess account. Please try again.", "error");
        const url = new URL(window.location);
        url.searchParams.delete("lichess");
        url.searchParams.delete("reason");
        window.history.replaceState({}, "", url.pathname + url.search);
    }
}

function showToast(message, type = "success") {
    toast.showToast({ title: message, type, duration: 5000 });
}

async function loadUserConfigFromServer() {
    const currentUser = store.get('user.currentUser');
    if (!currentUser) {
        return;
    }
    try {
        const config = await api.loadUserConfig();
        if (config && onConfigLoaded) {
            onConfigLoaded(config);
        }
    } catch (error) {
        console.error("Failed to load user configuration", error);
    }
}
